import { Stack, Badge, Chip } from "@mui/material";

const ChipYears = ({ years }) => {
    return(
        <Stack direction={'row'} spacing={2} sx={{ mt: '1em', justifyContent: 'center' }}>
            { years.map(({ year, total }, i) => 
                <Badge badgeContent={total} key={i} color="success"> 
                    <Chip label={year} variant="outlined" /> 
                </Badge>
            ) }
        </Stack>   
    )
}

export default ChipYears;